import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import '../App.css';
import { useState } from 'react';
import env from "react-dotenv"

function Login() {
    let navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Change background color
        document.body.style.backgroundColor = "#f8f9fe"
    }, [])


    async function handleSubmit() {
        const res = await fetch(env.BACKEND_URL + "/admin/login", {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + username + "&password=" + password,
            credentials: 'include'
        });

        if (res.ok)
            navigate("/main");
        else if (res.status === 401)
            setErrorMessage("E-mail ou mot de passe incorrect.")
        else
            setErrorMessage("Erreur inattendue : " + await res.text());
    }

    function handleChangeEmail(event) {
        setUsername(event.target.value);
    }

    function handleChangePassword(event) {
        setPassword(event.target.value);
    }
    
    return (
        <div className="login">
            <div className="login-form">
                <div className="login-error-text">
                    {errorMessage}
                </div>

                <div className="login-form-title">
                    E-MAIL
                </div>
                <div>
                    <input className="login-input-field" type="text" value={username} onChange={handleChangeEmail} />
                </div>
                <div className="login-form-title">
                    MOT DE PASSE
                </div>
                <div>
                    <input className="login-input-field" type="password" value={password} onChange={handleChangePassword} />
                </div>

                <div>
                    <button className="forgot-pw-button" onClick={() => navigate("/forgotten-password")}>Mot de passe oublié</button>
                </div>

                <div>
                    <button className="button" onClick={handleSubmit}>Connexion</button>
                </div>
            </div>
        </div>
    );
}

export default Login;